import { AxiosError } from 'axios';
import { GET_ANNOUNCEMENT_EXAM_LEVELS_URL } from 'web-library/constants/apiUrls';
import { GET_ANNOUNCEMENT_EXAM_LEVELS_QUERY_KEY } from 'web-library/constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { ConfigurationType } from '../../api/candidate/config/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  functionName: string;
  onSuccess?: (res: ConfigurationType[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetAnnouncementExamLevels = ({ functionName, onSuccess, onError }: Input) => {
  const getAnnouncementExamLevels = async () => {
    const res = await axiosClient.get<ConfigurationType[]>(
      GET_ANNOUNCEMENT_EXAM_LEVELS_URL(functionName)
    );
    return res.data;
  };

  return useCustomQuery(GET_ANNOUNCEMENT_EXAM_LEVELS_QUERY_KEY, getAnnouncementExamLevels, {
    onSuccess,
    onError,
  });
};
